import { Grid, Paper } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Grid container spacing={2} sx={{ opacity: 0.6, p: 3 }}>
      {/* <Grid item xs={6}>
        Term & Condition of Use
      </Grid>
      <Grid item xs={6} textAlign={"right"}>
        Contact Us
      </Grid>
      <Grid item xs={6}>
        Site Map
      </Grid>
      <Grid item xs={6} textAlign={"right"}>
        Saran & Perbaikan
      </Grid> */}
    </Grid>
    // <div className='container mt-5 box'>
    //     <hr></hr>
    //     <footer className="footer">
    //         <span className="text-muted">Term & Condition of Use  </span>
    //         <br></br>
    //         <span>Site Map</span>
    //     </footer>
    // </div>
  );
};

export default Footer;
